import { useEffect } from 'react'
import { useScrollContext } from '@/shared/provider/scroll-context/scroll-context.tsx'
import {
	DEFAULT_SECTION,
	type SectionId,
} from '@/teams/portfolio/types/section-id.ts'

/**
 * Scrolls to a section on page load based on the provided sectionId
 * Should be called once at the app/page level
 */
export function useScrollToSection(sectionId: SectionId) {
	const { startScrolling } = useScrollContext()

	useEffect(() => {
		if (sectionId !== DEFAULT_SECTION) {
			startScrolling()

			// Small delay to ensure DOM is ready
			requestAnimationFrame(() => {
				const element = document.getElementById(sectionId)
				if (element) {
					element.scrollIntoView({ behavior: 'smooth' })
				}
			})
		}
	}, [sectionId, startScrolling])
}
